import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageUtilWrapperService {
  private prefix: string;

  constructor() {
    this.prefix = window.location.hostname.split('.')[0];
  }

  get(key: string): any {
    try {
      const prefixedKey = this.getLocalKey(key);
      const storedValue = localStorage.getItem(prefixedKey);
      return storedValue ? JSON.parse(storedValue) : null;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  set(key: string, value: any): void {
    try {
      const prefixedKey = this.getLocalKey(key);
      localStorage.setItem(prefixedKey, JSON.stringify(value));
    } catch (error) {
      console.error(error);
    }
  }

  remove(key: string): void {
    try {
      const prefixedKey = this.getLocalKey(key);
      localStorage.removeItem(prefixedKey);
    } catch (error) {
      console.error(error);
    }
  }

  private getLocalKey(key: string): string {
    return `${this.prefix}_${key}`;
  }

  serializeMap(map: Map<string, Map<string, any>>): {
    [key: string]: { [innerKey: string]: any };
  } {
    const serializedValue: { [key: string]: { [innerKey: string]: any } } = {};

    map.forEach((innerMap, innerKey) => {
      serializedValue[innerKey] = {};
      innerMap.forEach((innerValue, innerValueKey) => {
        serializedValue[innerKey][innerValueKey] = innerValue;
      });
    });

    return serializedValue;
  }
}
